import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useOrgContext } from '@/shared/ui/hooks'
import { AppShellSkeleton } from '@/shared/ui/layout/app-shell-skeleton'

type RequireClubFeaturesProps = {
  children: ReactNode
}

export function RequireClubFeatures({ children }: RequireClubFeaturesProps) {
  const { orgType, clubFeaturesEnabled, isLoading } = useOrgContext()

  if (isLoading) return <AppShellSkeleton testId="club-features-loading" />

  if (orgType === 'outfitter' && clubFeaturesEnabled === false) {
    return <Navigate to="/no-access" replace />
  }

  return <>{children}</>
}
